import styled from 'styled-components';
import { Collapse } from 'antd';
import { flexRowCSS, flexColCSS } from '../styled';
import BaseTable from 'react-base-table';

const { Panel } = Collapse;

export const SessionDetailsWrapper = styled.div`
  min-width: 400px;
  min-height: 500px;
  height: 100%;
  position: relative;
  width: 30%;
  background-color: #fff;
  margin-left: 5px;
  overflow-y: auto;
  padding-top: 20px;
  padding-left: 20px;
  padding-right: 10px;
`;

export const HeaderWrapper = styled.div`
  flex-grow: 1;
  font-weight: 400;
  font-size: 20px;
  line-height: 20px;
  padding-bottom: 30px;
  flex-direction: row;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ViewerMetadataWrapper = styled.div`
  flex-grow: 1;
  font-weight: 300;
  font-size: 16px;
  line-height: 16px;
  padding-bottom: 5px;
  margin-top: 20px;
  flex-direction: column;
  display: flex;
`;

export const TableHeaderWrapper = styled.div`
  flex-grow: 1;
  font-weight: 500;
  font-size: 18px;
  line-height: 18px;
  padding-bottom: 5px;
  margin-top: 20px;
`;

export const TableWrapper = styled.div`
  min-height: 50px;
  margin: 20px 0;
  height: 320px;
  position: relative;
`;

export const ErrorListWrapper = styled.div`
  min-height: 50px;
  margin: 20px 0;
  height: 100px;
  position: relative;
`;

export const ErrorHeader = styled.div`
  font-weight: 500;
  font-size: 18px;
  line-height: 16px;
  margin-bottom: 10px;
`;

export const ErrorList = styled.li`
  font-weight: 300;
  font-size: 16px;
  line-height: 16px;
  margin: 3px 0;
`;

export const StyledBaseTable = styled(BaseTable)`
  font-size: 1.1em;
  border: none;
  box-shadow: none;

  .BaseTable__table-main {
    outline: none;
  }

  .BaseTable__row {
    &:hover {
      background-color: initial;
      border-bottom-color: #979797;
    }
  }

  .BaseTable__header-row {
    outline: none;
    font-weight: 300;
    background-color: #fff;
    border-bottom-width: 2px;
    border-bottom-color: #979797;
  }

  .BaseTable__header-cell-text {
    font-weight: 600;
  }
`;

export const NameWrapper = styled.div`
  flex-grow: 1;
  font-weight: 300;
  font-size: 16px;
  line-height: 16px;
  width: 35%;
`;

export const TileWrapper = styled.div`
  flex-grow: 1;
  ${flexRowCSS};
  align-items: center;
  background-color: #fff;
  min-height: 45px;
  width: 100%;
  padding: 2.5px 5px;
`;

export const ValueWrapper = styled.div`
  font-size: 14px;
  line-height: 16px;
  font-weight: 450;
  word-break: break-all;
  width: 65%;
  text-align: right;
`;

export const StyledGeoValue = styled.div`
  font-size: 14px;
  line-height: 16px;
  font-weight: 300;
  text-align: right;
`;

export const StyledPara = styled.p`
  font-size: 14px;
  ${flexColCSS};
  line-height: 16px;
  font-weight: 300;
  overflow-wrap: anywhere;
`;
// .ant-collapse > .ant-collapse-item > .ant-collapse-header
export const StyledPanel = styled(Panel)`
  background: #fff;
  margin-bottom: 5px;
  padding: 0 !important;
`;

export const StyledCollapse = styled(Collapse)`
  width: 100%;
  flex-grow: 1;

  &.ant-collapse {
    .ant-collapse-item {
      .ant-collapse-header {
        padding: 0 !important;
      }
    }
  }
`;

export const StyledMetricGroupRenderer = styled.div`
  width: 100%;
  ${flexColCSS};
  position: relative;
  margin-bottom: 10px;
  min-height: 60px;
`;
// overflow-y: scroll;
export const StyledStreamURLWrapper = styled.div`
  height: 35px;
  display: flex;
`;

export const StyledContentWrapper = styled.div`
  width: 100%;
  min-height: 40px;
`;

export const MetricDivider = styled.div`
  height: 1px;
  background: #979797;
  opacity: 1;
  margin: 2px;
  width: 100%;
`;

export const ToggleSwitch = styled.div`
  width: 100%;
  min-height: 40px;
`;

export const ToggleText = styled.span`
  display: inline-block;
  margin-left: 10px;
`;
